export const STUDENT_LIST_REQUEST = "STUDENT_LIST_REQUEST";
export const STUDENT_LIST_SUCCESS = "STUDENT_LIST_SUCCESS";
export const STUDENT_LIST_FAIL = "STUDENT_LIST_FAIL";

export const STUDENT_DETAILS_REQUEST = "STUDENT_DETAILS_REQUEST";
export const STUDENT_DETAILS_SUCCESS = "STUDENT_DETAILS_SUCCESS";
export const STUDENT_DETAILS_FAIL = "STUDENT_DETAILS_FAIL";

export const GET_STUDENT_EVENTS_REQUEST = "GET_STUDENT_EVENTS_REQUEST";
export const GET_STUDENT_EVENTS_SUCCESS = "GET_STUDENT_EVENTS_SUCCESS";
export const GET_STUDENT_EVENTS_FAIL = "GET_STUDENT_EVENTS_FAIL";
